module.exports = __webpack_public_path__ + "img/icon-grid.7b3bcb57.svg";